/** Polished user-facing generation phrases. No internal/process wording. */

export const INTRO_LOADING_PHRASES = [
  'Считываем главный ритм твоей даты',
  'Собираем активные числа периода',
  'Смотрим, где сейчас усиливается главный сюжет',
  'Соединяем значения в цельный разбор',
] as const;

export const INTRO_LOADING_SUBLINE = 'Формируем персональную картину периода';

export const INTRO_LOADING_PHASES = [
  'Ритм даты',
  'Числа периода',
  'Персональный текст',
] as const;

/** Neutral copy while a saved forecast is looked up; it must not imply that generation is running. */
export const DAILY_CHECKING = 'Открываю прогноз на сегодня';

export const DAILY_ERROR = {
  title: 'Не получилось собрать прогноз',
  body: 'Попробуем ещё раз - твои данные никуда не пропали.',
  retry: 'Повторить',
} as const;

export const REPORT_LOADING_PHRASES = [
  'Собираем активные числа периода',
  'Выделяем главный ресурс и напряжение',
  'Ищем сильные точки ближайших недель',
  'Формируем персональную картину периода',
] as const;

export const REPORT_LOADING_BY_PRODUCT: Record<string, readonly string[]> = {
  RELATIONSHIPS_V1: [
    'Собираем картину отношений',
    'Смотрим, где сейчас усиливается главный сюжет',
    'Выделяем главный ресурс и напряжение',
    'Соединяем значения в цельный разбор',
  ],
  MONEY_V1: [
    'Считываем главный ритм твоей даты',
    'Проверяем, какие числа сейчас звучат сильнее',
    'Ищем сильные точки ближайших недель',
    'Формируем персональную картину периода',
  ],
  CAREER_V1: [
    'Считываем главный ритм твоей даты',
    'Смотрим, где сейчас усиливается главный сюжет',
    'Выделяем главный ресурс и напряжение',
    'Соединяем значения в цельный разбор',
  ],
  PERSONAL_YEAR_V1: [
    'Собираем активные числа периода',
    'Сверяем твои числа с текущим периодом',
    'Ищем сильные точки ближайших недель',
    'Формируем персональную картину периода',
  ],
  COMPATIBILITY_V1: [
    'Собираем картину отношений',
    'Сверяем ритмы двух дат',
    'Выделяем точки притяжения и напряжения',
    'Соединяем значения в цельный разбор',
  ],
  PSYCHOMATRIX_V1: [
    'Раскладываем квадрат по твоей дате',
    'Считываем сильные и тихие линии',
    'Выделяем главный ресурс и напряжение',
    'Соединяем значения в цельный разбор',
  ],
  MATRIX22_V1: [
    'Собираем карту ключевых узлов',
    'Считываем центр и ближайшие опоры',
    'Проверяем, какие числа сейчас звучат сильнее',
    'Соединяем значения в цельный разбор',
  ],
};

export const PROFILE_LOADING = 'Открываем твою карту';
